import type { OptionsDocument, UserPreferencesDocument } from 'paintscout'
import type { ThemeOptions } from '@paintscout/ui'
import { createTheme } from '@paintscout/ui'

/**
 * Gets the default Theme prior to user authentication.
 */
export function getTheme(options?: OptionsDocument, preferences?: UserPreferencesDocument, removePrimaryColor = false) {
  const baseTheme: ThemeOptions = {
    palette: {
      primary: { main: '#595959' },
      secondary: { main: '#FFFFFF' }
    },
    zIndex: {
      mobileStepper: 1000,
      appBar: 1100,
      drawer: 1200,
      modal: 2_147_483_001,
      snackbar: 2_147_483_002,
      tooltip: 2_147_483_002
    }
  }

  if (!options) {
    return createTheme(baseTheme)
  }

  let fontScale = 1
  if (!options.options?.features?.fontScaling?.enabled) {
    fontScale = 0.9
  } else if (preferences?.fontScale) {
    fontScale = preferences.fontScale
  }

  const secondaryColor = '#FFFFFF'

  const primaryColor = removePrimaryColor ? '#024bb5' : (options.options.primaryColor.value as string)

  return createTheme({
    ...baseTheme,
    paintscout: {
      fontScale
    },
    palette: {
      primary: { main: primaryColor },
      secondary: { main: secondaryColor },
      error: { main: '#F44336' }
    }
  })
}
